import { useMemo } from 'react'
import transl from './searchResultsColumns.transl'

const columnMap = {
  actions: {
    id: 'actions',
    label: () => transl.actions(),
    size: 'lg',
  },
  ancestors: {
    defaultSelected: true,
    id: 'ancestors',
    label: () => transl.ancestors(),
    size: 'md',
  },
  ancestralHall: {
    defaultSelected: true,
    id: 'ancestralHall',
    label: () => transl.ancestralHall(),
    size: 'md',
  },
  archivalReferenceNumber: {
    id: 'archivalReferenceNumber',
    label: () => transl.archivalReferenceNumber(),
    size: 'lg',
  },
  authors: {
    id: 'author',
    label: () => transl.authors(),
    size: 'md',
  },
  cameraOperator: {
    id: 'cameraOperator',
    internalOnly: true,
    label: () => transl.cameraOperator(),
    size: 'md',
  },
  captureDate: {
    id: 'captureDate',
    label: () => transl.captureDate(),
    size: 'md',
  },
  childGroupCount: {
    id: 'childGroupCount',
    label: () => transl.childGroupCount(),
    size: 'sm',
  },
  clanBranches: {
    id: 'clanBranch',
    label: () => transl.clanBranches(),
    size: 'sm',
  },
  clans: {
    defaultSelected: true,
    id: 'clan',
    label: () => transl.clans(),
    size: 'sm',
  },
  creator: {
    id: 'creator',
    label: () => transl.creator(),
    size: 'md',
  },
  custodian: {
    id: 'custodian',
    label: () => transl.custodian(),
    size: 'md',
  },
  dateCreated: {
    id: 'dateCreated',
    label: () => transl.dateCreated(),
    size: 'md',
    sortable: true,
  },
  dateRange: {
    defaultSelected: true,
    id: 'dateRange',
    label: () => transl.dateRange(),
    size: 'md',
  },
  dgsNumber: {
    defaultSelected: true,
    id: 'dgsNumber',
    label: () => transl.dgsNumber(),
    size: 'md',
    sortable: true,
  },
  groupId: {
    id: 'groupId',
    label: () => transl.groupId(),
    size: 'md',
  },
  hasImages: {
    id: 'hasImages',
    label: () => transl.images(),
    size: 'sm',
  },
  imageRework: {
    id: 'imageRework',
    internalOnly: true,
    label: () => transl.imageRework(),
    size: 'md',
  },
  imagesIndexed: {
    id: 'imagesIndexed',
    label: () => transl.imagesIndexed(),
    size: 'md',
  },
  languages: {
    id: 'languages',
    label: () => transl.language(),
    size: 'sm',
  },
  mediaNumber: {
    id: 'mediaNumber',
    internalOnly: true,
    label: () => transl.mediaNumber(),
    size: 'xs',
  },
  migrantAncestor: {
    defaultSelected: false,
    id: 'migrantAncestor',
    label: () => transl.migrantAncestor(),
    size: 'md',
  },
  naturalGroupId: {
    id: 'naturalGroupId',
    internalOnly: true,
    label: () => transl.naturalGroupId(),
    size: 'md',
  },
  externalId: {
    id: 'externalId',
    internalOnly: true,
    label: () => transl.captureId(),
    size: 'md',
  },
  numberOfImages: {
    defaultSelected: true,
    id: 'numberOfImages',
    label: () => transl.numberOfImages(),
    size: 'sm',
  },
  places: {
    defaultSelected: true,
    id: 'place',
    label: () => transl.places(),
    size: 'lg',
  },
  projectId: {
    id: 'projectId',
    internalOnly: true,
    label: () => transl.projectId(),
    size: 'sm',
  },
  publicationYear: {
    id: 'publicationYear',
    label: () => transl.publicationYear(),
    size: 'sm',
  },
  recordTypes: {
    defaultSelected: true,
    id: 'recordTypes',
    label: () => transl.recordType(),
    size: 'lg',
  },
  title: {
    defaultSelected: true,
    id: 'title',
    label: () => transl.title(),
    size: 'md',
  },
  titleNumber: {
    defaultSelected: false,
    id: 'titleNumber',
    label: () => transl.titleNumber(),
    size: 'md',
  },
  totalVolumes: {
    defaultSelected: false,
    id: 'totalVolumes',
    label: () => transl.totalVolumes(),
    size: 'md',
  },
  volumes: {
    defaultSelected: true,
    id: 'volumes',
    label: () => transl.volumes(),
    size: 'md',
  },
  weekEndingDate: {
    defaultSelected: true,
    id: 'weekEndingDate',
    internalOnly: true,
    label: () => transl.weekEndingDate(),
    size: 'md',
  },
}

export default function useSearchResultsColumns() {
  const columns = useMemo(() => {
    const origninalColumns = {
      global: [
        columnMap.actions,
        columnMap.dgsNumber,
        columnMap.naturalGroupId,
        columnMap.externalId,
        columnMap.cameraOperator,
        columnMap.projectId,
        columnMap.mediaNumber,
        columnMap.weekEndingDate,
        columnMap.places,
        columnMap.dateRange,
        columnMap.recordTypes,
        columnMap.numberOfImages,
        columnMap.imagesIndexed,
        columnMap.title,
        columnMap.volumes,
        columnMap.languages,
        columnMap.creator,
        columnMap.custodian,
        columnMap.archivalReferenceNumber,
        columnMap.captureDate,
        columnMap.dateCreated,
        columnMap.imageRework,
      ],
      jiapu: [
        columnMap.groupId,
        columnMap.title,
        columnMap.places,
        columnMap.hasImages,
        columnMap.ancestralHall,
        columnMap.ancestors,
        columnMap.authors,
        columnMap.publicationYear,
        columnMap.titleNumber,
        columnMap.childGroupCount,
      ],
      jokbo: [
        columnMap.groupId,
        columnMap.title,
        columnMap.places,
        columnMap.hasImages,
        columnMap.clans,
        columnMap.clanBranches,
        columnMap.ancestors,
        columnMap.authors,
        columnMap.publicationYear,
        columnMap.titleNumber,
        columnMap.childGroupCount,
      ],
      keizu: [
        columnMap.groupId,
        columnMap.title,
        columnMap.places,
        columnMap.hasImages,
        columnMap.clans,
        columnMap.clanBranches,
        columnMap.ancestors,
        columnMap.authors,
        columnMap.publicationYear,
        columnMap.titleNumber,
        columnMap.childGroupCount,
        columnMap.dateRange,
        columnMap.migrantAncestor,
        columnMap.totalVolumes,
        columnMap.recordTypes,
        columnMap.volumes,
      ],
    }
    const activeColumn = {
      id: 'active',
      internalOnly: true,
      label: () => transl.activeHeader(),
      size: 'sm',
    }
    const index = origninalColumns.global.findIndex((column) => column.id === 'imageRework')
    if (index !== -1) {
      origninalColumns.global.splice(index, 0, activeColumn)
    }

    return origninalColumns
  }, [])

  return columns
}
